import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ImportSavedCartComponent } from './import-saved-cart.component'
import { FormsModule } from '@angular/forms'
import { CmsConfig, provideDefaultConfig } from '@spartacus/core'
import { SharedModule } from '../../shared/shared.module'
import { UserPermissionsGuard } from '../../../guards/user-permissions.guard'

@NgModule({
  declarations: [ImportSavedCartComponent],
  imports: [CommonModule, FormsModule, SharedModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ImportCSVSavedCartComponent: {
          component: ImportSavedCartComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class ImportSavedCartModule {}
